<template>
  <div>
    <div
      v-if="certificate.course_slug"
      class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4"
    >
      <div
        id="certificate"
        class="w-full max-w-6xl h-[780px] bg-[#faf9f7] shadow-2xl rounded-lg overflow-hidden md:flex hidden"
      >
      
        <!-- Left White Section -->
    <div
  class="w-[60%] p-10 relative flex flex-col items-center justify-between bg-no-repeat bg-cover bg-center bg-[#faf9f7]"
  :style="{
    backgroundImage: `url(${require('@/assets/certificate/Layer_13.png')})`,backgroundSize: '60%',
    backgroundPosition: 'center center'
  }"
>
  <div class="text-center mb-8">
    <h1
      class="text-6xl font-extrabold tracking-wider text-blue-900 uppercase mb-2"
      style="font-family: 'Cinzel', 'Times New Roman', serif; text-shadow: 1px 1px 1px rgba(0,0,0,0.05);"
    >
      CERTIFICATE
    </h1>

    <p
      class="text-2xl font-medium italic text-gray-600 tracking-wide"
      style="font-family: 'Playfair Display', Georgia, serif;"
    >
     ______ of Completion ______
    </p>
  </div>

  <div
    class="text-2xl text-gray-700 mb-6 text-center"
    style="font-family: 'Cinzel', 'Times New Roman', serif;"
  >
    This is to certify that
  </div>

  <div class="w-full flex-grow flex flex-col items-center justify-center">
    <div class="relative w-full max-w-xs mb-4">
      <div class="text-2xl font-semibold text-center text-gray-900">
        {{ certificate.display_name }}
      </div>
    </div>

    <div class="h-1 mb-2 w-full border-t-2 border-gray-800"></div>

    <div class="flex flex-col gap-4 text-center">
      <p
        class="text-xl font-medium italic text-gray-600 tracking-wide"
        style="font-family: 'Inter', sans-serif;"
      >
        has successfully completed the course
      </p>

      <p
        class="text-xl font-bold text-black italic tracking-wide mb-5"
        style="font-family: 'Inter', sans-serif;"
      >
        {{ certificate.course_title }}
      </p>
    </div>
  </div>

  <div class="w-full text-left mt-4 flex justify-between items-center">
    <div class="flex flex-col gap-1">
      <img
        v-if="qrCodeData"
        :src="qrCodeData"
        class="w-20 h-20 object-contain"
      />

      <p class="text-sm text-gray-600">
        S.I.No. {{ certificate.course_id || '000001' }}
      </p>
    </div>

    <div class="flex justify-center mt-10">
      <div class="text-center w-48">
 <div class="text-center">
  <img src="@/assets/certificate/Rectangle(1).png" alt="" srcset="">
 </div>
        <div class="border-t border-gray-400 w-full"></div>

        <p class="text-sm text-gray-600 mt-2">
          Authorized Signature
        </p>

        <p class="text-sm text-gray-600">
          Alliance Online
        </p>
      </div>
    </div>
  </div>
</div>

        <div class="w-[45%] relative border-none ">
          <svg
            class="absolute top-0 right-0 w-full h-full"
            viewBox="0 0 500"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_2412_4105)">
              <path
                d="M36.2714 726.854C30.5573 755.904 29.9879 786.296 34.9628 815.527C37.5002 830.407 41.4661 844.994 47.0603 858.735C48.0693 861.217 49.1882 863.732 50.5368 866H29.5783C28.2197 863.721 27.1008 861.194 26.0819 858.701C20.4876 844.949 16.5217 830.362 13.9843 815.493C9.00945 786.263 9.57886 755.87 15.293 726.82C21.097 697.286 32.0458 669.454 41.1864 641.047C61.6853 577.363 73.2734 509.235 69.2176 441.534C64.6323 365.023 40.8567 292.563 23.4046 219.154C5.68286 144.629 2.38627 76.4207 9.49896 0H30.4774C23.3647 76.432 26.6613 144.629 44.3831 219.165C61.8351 292.574 85.6108 365.046 90.1961 441.557C94.2519 509.257 82.6637 577.375 62.1648 641.081C53.0242 669.488 42.0755 697.319 36.2714 726.854Z"
                fill="#7C0902"
              />
              <path
                d="M500 0V900H56.641C55.2794 863.721 54.148 861.183 53.1268 858.69C47.52 844.95 43.5452 830.364 41.0022 815.485C36.0162 786.256 36.5869 755.866 42.3138 726.818C48.1308 697.285 59.104 669.456 68.265 641.051C88.8097 577.36 100.424 509.235 96.3589 441.54C91.7634 365.034 67.9346 292.566 50.4435 219.162C32.6822 144.63 29.3782 76.427 36.5068 0.0112807H446V0Z"
                fill="#003467"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_2412_4105"
                x="0"
                y="0"
                width="500"
                height="900"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dx="-6" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2412_4105"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2412_4105"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
          <div
            class="relative z-10 h-full p-10 text-white flex flex-col items-center"
          >
            <div class="mb-8 ml-10">
              <div class="w-[200px] h-[200px]">
                <img
                  :src="logo_image"
                  alt=""
                  srcset=""
                  class=" object-contain"
                />
              </div>
            </div>

            <div
              v-if="certificate.profile_image"
              class="mb-8 flex justify-center md:justify-start"
            >
              <img
                :src="certificate.profile_image"
                crossorigin="anonymous"
                class="w-32 h-32 rounded-full object-cover shadow-lg"
              />
            </div>

            <div class="mt-auto flex flex-col gap-10 ml-20">
              <div class="w-full">
                <h3 class="text-lg font-bold mb-3  pb-2 inline-block">
                  Course Coverage
                </h3>
                <ul class="space-y-3 text-xs">
                  <li class="flex items-center">
                    <span class="mr-2"
                      ><img src="@/assets/Group(3).svg" alt="" srcset=""
                    /></span>
                    <span>Principles of corporate communication</span>
                  </li>
                  <li class="flex items-center">
                    <span class="mr-2"
                      ><img src="@/assets/Group(3).svg" alt="" srcset=""
                    /></span>
                    <span>Organizational and leadership communication</span>
                  </li>
                  <li class="flex items-center">
                    <span class="mr-2"
                      ><img src="@/assets/Group(3).svg" alt="" srcset=""
                    /></span>
                    <span>Professional written, verbal, and visual skills</span>
                  </li>
                  <li class="flex items-center">
                    <span class="mr-2"
                      ><img src="@/assets/Group(3).svg" alt="" srcset=""
                    /></span>
                    <span>Public relations and crisis communication</span>
                  </li>
                </ul>
              </div>

              <div class="w-full text-center">
                <p class="text-xl font-light text-[#ED9740]">
                  allianceonline.edu.in
                </p>
              </div>
            </div>
          </div>
        </div>
     
      </div>

      <div class="mt-8">
        <button
          @click="downloadCertificate"
          class="px-6 py-3 bg-blues text-white font-semibold rounded-lg shadow-md hover:bg-hover transition duration-300 flex items-center"
        >
          <svg
            class="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          Download Certificate
        </button>
      </div>
    </div>
    <div v-else class="flex flex-col items-center justify-center h-screen">
      No Data Found
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import QRCode from "qrcode";

export default {
  name: "CertificateDesign",
  data() {
    return {
      certificate: {},
      logo_image: require(`${process.env.VUE_APP_CERTIFICATE_LOGO}`),
      qrCodeData: "",
    };
  },
  props: ["complete_course_slug", "complete_profile_slug"],
  computed: {
    ...mapGetters("student", [
      "studentdata"]),
  },

  created() {
    this.completecourse();
  },
  mounted() {
    this.loadHtml2Canvas();
  },
  methods: {
    async loadHtml2Canvas() {
      const script = document.createElement("script");
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
      script.onload = () => console.log("html2canvas loaded");
      document.body.appendChild(script);
    },

    async completecourse() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/student-completed/details/?course_slug=${this.complete_course_slug}&profile_slug=${this.complete_profile_slug}`
        );
        if (response.data?.status == 200) {
          this.certificate = response.data?.data?.[0] || {};
          console.log(" this.certificate///////", this.certificate);
          if (this.certificate.course_slug && this.certificate.profile_slug) {
            const qrUrl =
              `${process.env.VUE_APP_FRONTEND_DOMAIN}/certificate/` +
              `?course_slug=${this.certificate.course_slug}` +
              `&profile_slug=${this.certificate.profile_slug}`;

            this.qrCodeData = await QRCode.toDataURL(qrUrl, {
              errorCorrectionLevel: "M",
              margin: 4,
              width: 256,
              color: {
                dark: "#000000",
                light: "#ffffff",
              },
            });
          }
        } else {
          this.certificate = {};
        }
      } catch (error) {
        console.error("Error fetching certificate data:", error);
          this.certificate = {};
      }
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

  
    async downloadCertificate() {
  const certificateElement = document.getElementById("certificate");

  await this.$nextTick();

  const images = certificateElement.getElementsByTagName("img");

  await Promise.all(
    Array.from(images).map((img) => {
      if (img.complete) return Promise.resolve();

      return new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      });
    })
  );

  const canvas = await window.html2canvas(certificateElement, {
    scale: 3,
    useCORS: true,
    allowTaint: false,
    backgroundColor: "#ffffff",
  });

  const link = document.createElement("a");

  link.href = canvas.toDataURL("image/jpeg", 1.0);

  const fileName = `${this.certificate.display_name.replace(/\s+/g, "_")}_${this.certificate.course_title.replace(/\s+/g, "_")}.jpg`;

  link.download = fileName;

  link.click();
}
  },
};
</script>

<style scoped>
/* Additional styles for better appearance */
#certificate {
  font-family: "Times New Roman", Times, serif;
}

/* Print-specific styles */
@media print {
  body * {
    visibility: hidden;
  }
  #certificate,
  #certificate * {
    visibility: visible;
  }
  #certificate {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    box-shadow: none;
  }
}
</style>
